import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    type: 'customTaxonomies',
    list: [],
    customTaxonomies: [],
    hierarchies: {},
    selected: null,
    hierarchyIsAlreadyRetrieved: false,
    isLoading: false,
    builderIsLoading: false,
    collection: {},
    tree: {},
    taxonomiesCount: null,
    segmentsCount: null,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
